<!--
 * @创建文件时间: 2020-01-12 11:01:23
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-07-15 17:21:09
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-15 22:56:28
 * @联系Qq:1638245306
 * @文件介绍: 导入文件
 -->

<template>
<div style="display:inline-block;padding:0px 10px;">
<el-dialog
  title="导入"
  :visible.sync="fileShow"
  @close="$emit('update:dialogShow', false)"
  :show-close="false" :append-to-body="true" :close-on-click-modal="false"
  width="45%">
  <p style="font-size:16px;">1. 请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除</p>
     <el-button type="success" icon="el-icon-download" style="margin-bottom:10px;" :loading="btnLoading" @click="downloadFile">模板下载</el-button>
  <p style="font-size:16px;">2. 文件后缀名必须为：xlsx（即Excel格式,csv格式需转为xlsx）</p>
  
  <p style="font-size:16px;">3. 请选择或拖拽需要导入的Excel文件</p>
    <el-upload
    :ref='refName'
    :headers="myHeaders"
    :action="importUrl"
    drag
    :auto-upload="true"
    :file-list="fileList"
    :on-success='successHandle'
    :on-error="errorHandle"
      multiple
    >
   <i class="el-icon-upload"></i>
  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
  <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
    </el-upload>
    <div slot="footer">
    <el-button @click="cancel">取 消</el-button>
    <!-- <el-button type="primary" @click="submitUpload">确 定</el-button> -->
  </div>
</el-dialog>
</div>
</template>
<script>
  import util from '@/libs/util.js'
  export default {
    data() {
      return {
        refName:'',
        imgVisible:false,
        fileList:[],
        dialogImageUrl: '',
        fileShow:this.dialogShow,
        btnLoading:false,
        myHeaders:{

        }
      };
    },
    props:{
       dialogShow:{
           type:Boolean,
           default:false
       },
       importUrl:{
         type:String
       },
       exportFile:{
          type:String
       }
    },
    watch:{
        dialogShow(val, oldVal) {
        if (val === oldVal) {
            return
        }
        this.fileShow = val
        }
    },
    methods: {
      uploadFile(){

      },
      //成功后的回调
      successHandle(response, file, fileList){
         this.fileShow = false
         let res={};
         if(Array.isArray(fileList)){
           res=fileList[0].response;
         }else{
           res=fileList.response;
         }
         let msg = res.resultMsg;
         if(res.resultCode===2000){
            this.$message.success("导入成功")
            this.$router.push('refresh')
         }else if(res.resultCode===9001){
           this.$message.error("导入失败")
           this.fileList = []
         }else{
            this.$message.error(msg)
            this.fileList = []
         }

         this.cancel();
      },
      //失败后的回调
      errorHandle(response, file, fileList){
        this.fileList = []
      },
      handleRemove(file, fileList) {
      },
      cancel(){
        this.fileShow=false;
        this.$emit('cancel');
      },
      // handlePictureCardPreview(file) {
      //   this.dialogImageUrl = file.url;
      //   this.imgVisible = true;
      // },
       //验证是否是图片
    //  beforeAvatarUpload(file) {
    //       var isFile; 
    //     var imgType= file.name.substring(file.name.lastIndexOf('.')+1)
    //     switch(imgType){
    //       case 'doc':
    //         isFile = true
    //         break;
    //       case 'docx':
    //         isFile = true
    //         break;
    //       default:
    //         isFile = false
    //     }
    //     if (!isFile) {
    //       this.$message.error('文件类型为Word,PDF等主流文件');
    //     }
    //     const isLt2M = file.size / 1024 / 1024 < 2;
    //     if (!isLt2M) {
    //       this.$message.error('上传文件大小不能超过 2MB!');
    //     }
    //     return isFile && isLt2M;
    //   },
      // //文件上传限制
      // handleExceed(files, fileList) {
      //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      // },
      //删除文件
      // beforeRemove(file, fileList) {
      //   return this.$confirm(`确定移除 ${ file.name }？`);
      // }
      
      /**模板下载 */
      downloadFile(){
        let that = this
        that.btnLoading = true
        setTimeout(function(){
          that.btnLoading = false
          },"2000");
        window.open(this.$url.downLoadFile + '?exportType=' + this.exportFile,'_blank')
      },
      getUserToken(){
        let token = util.session.get("token")
        this.myHeaders = {
          userToken:token
        }
      }
    },
    created(){
         this.refName = 'uploadFile' + new Date().getTime()
    },
    mounted() {
      this.getUserToken()
    }
  }
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/DialogUploadFile.vue"
}
</vue-filename-injector>
